<template>
  <v-container>
    <v-row justify="center" class="mt-2">
      <p>
        To ensure that your browser supports audio playback, please click the
        button below. If you do not hear any audio, please contact the
        experimenter.
      </p>
    </v-row>
    <v-row no-gutters class="mt-2" justify="center">
      <v-btn @click="play()" v-if="isPlaying == false"
        >Play Test Sound <v-icon>play_circle_filled</v-icon></v-btn
      >
      <v-btn @click="stop()" v-if="isPlaying == true"
        >Stop Test Sound <v-icon>stop_circle</v-icon></v-btn
      >
    </v-row>
    <v-row justify="center" class="mt-10"> <p>Do you hear audio?</p></v-row>
    <v-row no-gutters class="mt-2 mb-10" justify="center">
      <v-btn @click="yes()" class="mr-5 success" :disabled="listens <= 0"
        >Yes <v-icon>check</v-icon></v-btn
      >
      <v-btn @click="no()" class="primary error" :disabled="listens <= 0"
        >No <v-icon>close</v-icon></v-btn
      >
    </v-row>
  </v-container>
</template>

<script>
import { Howl, Howler } from "howler";
import { ref } from "@vue/composition-api";
import Vue from "vue";
import router from "@/router";
import store from "@/store";
export default {
  name: "AudioTest",
  setup() {
    const no = () => {
      Howler.stop();
      isPlaying.value = false;
      Vue.prototype.$dialog.info({
        title: "Audio Test Failed",
        text: "Please make sure you headphone volume is turned up. If you still do not hear any audio, please contact the experimenter.",
      });
    };

    const yes = () => {
      Howler.stop();
      isPlaying.value = false;
      store.commit("setLocked", false);
      router.push("/introduction");
    };

    const isPlaying = ref(false);
    const listens = ref(0);

    const play = () => {
      Howler.stop();
      isPlaying.value = true;
      var sound = new Howl({
        src: ["audio/test_audio.mp3"],
        volume: 1,
        onload: () => {
          sound.play();
          listens.value += 1;
        },
        onloaderror: () => {
          listens.value = 0;
          isPlaying.value = false;
          Vue.prototype.$dialog.error({
            text: "Could not load sound file",
            title: "Error",
          });
        },
        onend: () => {
          listens.value += 1;
          isPlaying.value = false;
        },
      });
    };

    const stop = () => {
      isPlaying.value = false;
      Howler.stop();
    };

    return { yes, no, play, stop, isPlaying, listens };
  },
};
</script>

